import script from "./Kyc.vue?vue&type=script&setup=true&lang=ts"
export * from "./Kyc.vue?vue&type=script&setup=true&lang=ts"

import "./Kyc.vue?vue&type=style&index=0&id=5089544a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5089544a"]])

export default __exports__